import request from '@/utils/request'

export function getCampaign (id) {
    return request({
      url: `/campaign/all?toutiaoIdList=${id}`,
      method: 'get'
    })
}

export function getPlan (id) {
    return request({
      url: `/ad/all?toutiaoIdList=${id}`,
      method: 'get'
    })
}

export function getCreative (id) {
    return request({
      url: `/creative/all?toutiaoIdList=${id}`,
      method: 'get'
    })
}

export function searchAd (mode, keyword) {
    let modeMap = {
        campaign: 'AUDIENCE_SEARCH_COMPAIGN',
        plan: 'AUDIENCE_SEARCH_AD',
        creative: 'AUDIENCE_SEARCH_CREATIVE'
    }
    return request({
      url: `/audience-integrated-report/search?type=${modeMap[mode]}&keyword=${keyword}`,
      method: 'get'
    })
}

export function getTiktokCampaign (id) {
  return request({
    url: `/tiktok-campaign/all?tiktokIdList=${id}`,
    method: 'get'
  })
}

export function getTiktokAdgroup (id) {
  return request({
    url: `/tiktok-adgroup/all?tiktokIdList=${id}`,
    method: 'get'
  })
}

export function getTiktokAd (id) {
  return request({
    url: `/tiktok-ad/all?tiktokIdList=${id}`,
    method: 'get'
  })
}

// 保存文件信息
export function saveFileInfo(data) {
  return request({
    url: '/files/upload-with-mata',
    data: data,
    method: 'post'
  })
}